import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isChristmasPeriod } from '../utils/christmasTheme';
import { trackNavigationClick } from '../utils/analytics';
import '../styles/Navigation.css';
import '../styles/christmas.css';

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isChristmas = isChristmasPeriod();

  const isActive = (path: string): boolean => {
    return location.pathname === path;
  };

  const handleNavigation = (path: string) => {
    trackNavigationClick(path, location.pathname);
    navigate(path);
  };

  return (
    <nav className={`navigation ${isChristmas ? 'christmas' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo" onClick={() => handleNavigation('/')}>
          <img src="/thanksbeer.ico" alt="Beer" className="nav-logo-icon" />
          ThanksBeer
        </div>
        <ul className="nav-links">
          <li>
            <button 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => handleNavigation('/')}
            >
              Home
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
              onClick={() => handleNavigation('/about')}
            >
              About
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${isActive('/how-it-works') ? 'active' : ''}`}
              onClick={() => handleNavigation('/how-it-works')}
            >
              How It Works
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
              onClick={() => handleNavigation('/contact')}
            >
              Contact
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
